export enum ETableSource {
  // data is fetched page by page
  dynamic = 0,
  // data fetched at once
  static = 1,
  // data is already fetched just visualise it
  fetched = 2
}
